// TODO: remove all this after finish of refactoring
//  if we would not need css variables from stylable panel
import { getStyleId, createCssVarsObject } from '../../../utils/stylableUtils';
import { InjectCssVars } from './types';

export const createInjectCssVars_column =
  (stylableClassName: string): InjectCssVars =>
  depth => {
    if (depth !== 0) {
      return {};
    }

    const styleId = getStyleId(stylableClassName);
    return {
      list: createCssVarsObject(styleId, 'horizontalSpacing'),
    };
  };
